import { Glyph } from "../../types";

const SvgCrossCircle: Glyph = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
             10-4.48 10-10S17.52 2 12 2zm4.3 13.3l-1.4 1.4L12 13.4
             9.1 16.7l-1.4-1.4L10.6 12 7.7 9.1l1.4-1.4L12 10.6
             l2.9-2.9 1.4 1.4L13.4 12l2.9 2.9z"
    />
  </svg>
);

export default SvgCrossCircle;
